import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(3, 0),
  [theme.breakpoints.down('xxl')]: {
    padding: theme.spacing(3, 0),
  },
  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(3, 0),
  },
  '& .WCSSIconCard': {
    height: '100%',
  },
  '& .WCSSIcon': {
    width: theme.typography.pxToRem(79),
    height: theme.typography.pxToRem(80),
    background: theme.palette.secondary.main,
    borderRadius: theme.typography.pxToRem(100),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
    '&.WCSSIconFill': {
      fill: theme.palette.secondary.main,
      background: 'unset',
      borderRadius: 0,
    },
  },
  '& .WCSSTitle': {
    marginBottom: theme.spacing(0.5),
  },
}));

export default StyledBox;
